import {FC} from 'react';
import {Modal} from '@components/Modal';
import {Typography} from '@components/Typography';
import {Button} from '@components/Button';
import {FormattedMessage} from 'react-intl';

export type FlationModalProps = {
    show: boolean;
    onHide: () => any;
};

export const FlatioModal: FC<FlationModalProps> = ({show, onHide}) => {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton closeLabel="Zavřít">
                <Modal.Title>
                    <Typography as="h2" variant="subheadline" className="mb-0">
                        <FormattedMessage defaultMessage={'Co je Flatio'}/>
                    </Typography>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Typography as={"p"}>
                    <FormattedMessage
                        defaultMessage={"Flatio nabízí plně vybavené byty a pokoje k okamžitému pronájmu, při kterém není nutné platit provizi ani vratnou kauci. Při rezervaci bydlení na 6 až 12 měsíců platíte jenom nájem a servisní poplatek, který pokrývá náklady Flatio na ověřování nabídek, záruku bezpečnosti a uživatelskou podporu po celou dobu bydlení. Poplatky za energie a internet jsou již zahrnuty v ceně nájmu."}/>
                </Typography>

                <Button variant={"outline-secondary"} onClick={onHide}>
                    <FormattedMessage defaultMessage={"Zavřít"}/>
                </Button>
            </Modal.Body>
        </Modal>
    );
};
